import React from 'react';
import { Component } from '@poa/core';
import { observable } from '@poa/state';
import Spinner from 'react-spinkit';

import Navbar from '../components/navbar';
import RouteLoading from '../components/route-loading';
import DraggableComponent from '../components/draggable-component/draggable-component';
import DashboardFilter from '../components/dashboard-filter';

class HomePage extends React.Component {
  localState = observable({ left: null, top: 0, loading: false });
  store; // injected by Poa
  actions; // injected by Poa
  t; // injected by Poa

  onDatesChange = async ({ startDate, endDate }) => {
    this.localState.loading = true;
    try {
      await this.actions.homeActions.setDates(startDate, endDate);
    } catch (e) {
    } finally {
      this.localState.loading = false;
    }
  };

  render() {
    // const { selectors, filters } = this.store.home;
    return (
      <RouteLoading
        meta={this.store.home.meta}
        render={() => {
          return (
            <>
              <Navbar />
              <div className='container home'>
                <div>
                  <DashboardFilter
                    render={() =>
                      [<div key={''} style={{ display: 'flex' }}>
                        <div style={{ verticalAlign: 'middle' }}>
                          <button type='button' className='archive_button'>
                            ОБНОВИТЬ
                          </button>
                        </div>
                      </div>]
                    } />
                </div>
                {this.localState.loading ? (
                  <div className='dashboard'>
                    <div
                      className='spinner-loading'
                      style={{ paddingTop: '75px', textAlign: 'center' }}
                    >
                      <Spinner name='folding-cube' fadeIn='none' />
                    </div>
                  </div>
                ) : (
                  <div className='dashboard'>
                    <DraggableComponent name='card' position_y='200' position_x='500' />
                    <DraggableComponent name='long-card' position_y='500' position_x='300' />
                    <DraggableComponent name='card-high' position_y='700' position_x='800' />
                    <DraggableComponent name='card' position_y='300' position_x='100' />
                    <DraggableComponent name='card' position_y='300' position_x='300' />

                  </div>
                )}
              </div>
            </>
          );
        }}
      />
    );
  }
}

export default Component({ namespaces: ['home'] })(HomePage);
